module.exports = __webpack_public_path__ + "media/images/pic/orange-pin-0a493a33555a07e5f6c5db200cd3f17d.svg";